var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WidgetCard',{attrs:{"title":"Företag att godkänna","subtitle":"Att hantera"}},[_c('v-data-table',{class:'clickable',attrs:{"hide-default-footer":"","headers":[
      {text: 'Företagsnamn', value: 'name'},
      {text: 'Org.nr.', value: 'organizationalNumber'},
      {text: 'Avtalstyp', value: 'contracttype.name'},
      {text: 'Adress', value: 'postalAddress1'},
      {text: 'Postnr', value: 'postalZip'},
      {text: 'Ort', value: 'postalCity'},
    ],"items":_vm.items,"items-per-page":-1,"server-items-length":_vm.totalRows,"item-key":"id"},on:{"click:row":_vm.showCompany}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }